const IconChatAvatar = ({ isCustomer, size = 20 }) => {
  return (
    <i
      className="fad fa-user-circle"
      style={{
        fontSize: size,
        "--fa-primary-color": "#ffffff",
        "--fa-secondary-color": isCustomer ? "#1dd1f5" : "#fcb71e",
        "--fa-secondary-opacity": 1,
      }}
    />
  );
};

export default IconChatAvatar;
